import { isFreeTrialEligibleAsync } from './isFreeTrialEligibleAsync'

export const isFreeTrialCartEnabledAsync = async (
  isGift = false,
  refresh = false,
) => {
  const freeTrialEligible = await isFreeTrialEligibleAsync(refresh)

  return freeTrialEligible && !isGift
}
